import { HttpClient, HttpStatusCode } from 'data/protocols/http';
import { generateUrl } from 'data/utils';
import { UnexpectedError } from 'domain/errors';
import { BadRequestError } from 'domain/errors/bad-request-error';
import { HandleProfessionListUseCaseInterface } from 'domain/usecases';

export class RemoteProfession implements HandleProfessionListUseCaseInterface {
  constructor(
    private readonly url: string,
    private readonly httpClient: HttpClient<HandleProfessionListUseCaseInterface.Result>,
  ) {}

  async execute(
    params: HandleProfessionListUseCaseInterface.Params,
  ): Promise<HandleProfessionListUseCaseInterface.Result> {
    const httpResponse = await this.httpClient.request({
      method: 'get',
      url: generateUrl(this.url, { ...params }),
    });

    switch (httpResponse.statusCode) {
      case HttpStatusCode.badRequest:
        throw new BadRequestError();
      case HttpStatusCode.ok:
        return httpResponse.body;
      default:
        throw new UnexpectedError();
    }
  }
}
